import { createSlice } from "@reduxjs/toolkit";
import {
  viewTraining,
  singleTraining,
  addTraining,
  updateTraining,
  deleteTraining,
  singleUserTraining,
  approveTraining,
  approvedTrainingList,
} from "../actions/trainingAction";

const trainingSlice = createSlice({
  name: "training",
  initialState: {
    training: [],
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(updateTraining.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTraining.fulfilled, (state, action) => {
        state.loading = false;
        state.training = action.payload;
      })
      .addCase(updateTraining.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteTraining.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteTraining.fulfilled, (state, action) => {
        state.loading = false;
        state.training = action.payload;
      })
      .addCase(deleteTraining.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(singleTraining.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(singleTraining.fulfilled, (state, action) => {
        state.loading = false;
        state.training = action.payload;
      })
      .addCase(singleTraining.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(addTraining.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addTraining.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.training = action.payload;
      })
      .addCase(addTraining.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(singleUserTraining.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(singleUserTraining.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.training = action.payload;
      })
      .addCase(singleUserTraining.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(approveTraining.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(approveTraining.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.training = action.payload;
      })
      .addCase(approveTraining.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },

  extraReducers: (builder) => {
    builder
      .addCase(viewTraining.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(viewTraining.fulfilled, (state, action) => {
        state.loading = false;
        state.training = action.payload;
      })
      .addCase(viewTraining.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(approvedTrainingList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(approvedTrainingList.fulfilled, (state, action) => {
        state.loading = false;
        state.training = action.payload;
      })
      .addCase(approvedTrainingList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default trainingSlice.reducer;
